<template>
  <div class="row">
    <div class="col-md-6">
      <div class="player">
        <iframe class="mb-3" width="100%" height="350" :src="videoData.youtubeEmbedUrl" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
      </div>
    </div>
    <div class="col-md-5">
      <form>
        <div class="row mb-3">
          <div class="col-6">
            <div class="input-box">
            <label for="duration" class="form-label">Duration</label>
            <input type="text" id="duration" disabled class="form-control" v-model="videoData.duration">
          </div>
          </div>
          <div class="col-6">
            <label class="form-label" for="duration">Video Visibility</label>
            <select class="visible-drop" v-model="videoData.visibility" name="visibility" id="visibility">
              <option selected value="false">Private</option>
              <option value="true">Public</option>
            </select>
          </div>
        </div>

        <div class="mb-3">
          <label for="start-time" class="form-label">Title</label>
          <input type="text" id="start-time" class="form-control" v-model="videoData.title">
        </div>


        <div class="row">
          <div class="col-5">
            <label for="start-time" class="form-label">Start Time</label>
          </div>
          <div class="col-5">
            <label for="end-time" class="form-label">End Time</label>
          </div>
        </div>

        <div v-for="(step, index) in videoData.steps">
          <div class="row">
            <div class="col-5 form-group">
              <input type="text" id="start-time" min="0" required class="form-control" v-model="step.start">
            </div>

            <div class="col-5 form-group">
              <input type="text" id="end-time" min="0" required class="form-control" v-model="step.end">
            </div>
            <div v-if="index > 0" class="col-1">
              <b-icon-x-square class="pt-1 step-icon" @click="removeTimeRow(index)"></b-icon-x-square>
            </div>
          </div>
        </div>

        <div class="form-group">
          <b-icon-plus-square class="step-icon" @click="addSteps()"></b-icon-plus-square>
        </div>

        <!-- <div class="container input-box">
      <div class="mb-3 mr-2">
        <label for="start-time" class="form-label">Start Time</label>
        <input type="text" id="start-time" class="form-control" v-model="videoData.start">
      </div>
      <div class="mb-3">
        <label for="end-time" class="form-label">End Time</label>
        <input type="text" id="end-time" class="form-control" v-model="videoData.end">
      </div>
    </div> -->
        <!-- <div class="mb-3 ml-3">
            <label for="intensity" class="form-label">Intensity: {{ videoData.intensity }}</label>
            <input type="range" id="intensity" max="10" min="1" class="form-control" v-model="videoData.intensity">
          </div> -->
        <div class="mb-3">
          <label for="description" class="form-label">Description</label>
          <textarea id="description" class="form-control" v-model="videoData.description"></textarea>
        </div>
        <div v-if="videoData.category.length > 0" class="mb-3">
          <label for="category" class="form-label">Category</label>
          <input type="text" id="category" class="form-control" v-model="videoData.category">
        </div>
        <div v-if="videoData.bodyFocus.length > 0" class="mb-3">
          <label for="body-focus" class="form-label">Body Focus</label>
          <input type="text" id="body-focus" class="form-control" v-model="videoData.bodyFocus">
        </div>
        <div class="mb-3 ml-3">
          <b-button class="btn btn-primary" @click="updateVideo()">Update</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from '../../api.js';
import { VIDEO_DATA } from '../../utils/constants.js';
export default {
  name: 'video-edit',
  props: {
    videoId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      videoData: {
        'videoUrl': '',
        'youtubeEmbedUrl': '',
        'duration': '',
        'start': '',
        'end': '',
        'intensity': '',
        'description': '',
        'category': [],
        'bodyFocus': []
      },
      data: VIDEO_DATA,
      passedVideoId: this.videoId,
      showThumbail: true,
      stepNumber: null,
      stepParts: [{
      hx: 1.1,
      hy: 6,
      lx: 1.1,
      ly: 2,
      part: "elbow"
    }, {
      hx: 1.1,
      hy: 6,
      lx: 1.1,
      ly: 2,
      part: "wrist"
    }, {
      hx: 1.2,
      hy: 6,
      lx: 1.2,
      ly: 2,
      part: "knee"
    }, {
      hx: 1.2,
      hy: 6,
      lx: 1.2,
      ly: 2,
      part: "hip"
    }, {
      hx: 1.2,
      hy: 6,
      lx: 1.2,
      ly: 2,
      part: "ankle"
    }],
    }
  },
  methods: {
    async getVideoData() {
      try {
        let response = await api.getVideoById(this.videoId);
        if (response.status == 200) {
          this.videoData['id'] = response.data.data.id;
          this.videoData['title'] = response.data.data.title;
          this.videoData['visibility'] = response.data.data.is_public;
          this.videoData['videoUrl'] = `https://www.youtube.com/watch?v=${response.data.data.youtube_embed_id}`;
          this.videoData['youtubeEmbedUrl'] = `https://www.youtube.com/embed/${response.data.data.youtube_embed_id}`;
          this.videoData['duration'] = response.data.data.duration;
          this.videoData['start'] = response.data.data.data.start;
          this.videoData['end'] = response.data.data.data.end;
          this.videoData['intensity'] = response.data.data.intensity;
          this.videoData['description'] = response.data.data.description;
          this.videoData['steps'] = response.data.data.data.steps;
          this.stepNumber = this.videoData.steps.length;
          this.stepParts = this.videoData.steps[0].parts;
        }
      }
      catch (error) {
        this.$bvToast.toast('INTERNAL SERVER ERROR', {
          variant: 'danger'
        });
      }
    },
    addSteps() {
      this.videoData.steps.push({
        start: null,
        end: null,
        step: "Step " + ++this.stepNumber,
        parts: this.stepParts,
      });
      this.$forceUpdate();
    },
    removeTimeRow(index) {
      this.videoData.steps.splice(index, 1);
      this.$forceUpdate();    
    },
    async playVideo() {
      this.showthumbail = false;
    },
    async updateVideo() {
      // Set updated start, end time
      const message = this.validateTimeIntervals(this.videoData['steps'])
      if(!message.isValid){
        this.$bvToast.toast(message.message, {
          title : "Error",
          variant: "danger",
        });
        return
      }
      this.data.steps = this.videoData['steps'];
      this.data.start = parseInt(this.data.steps[0].start);
      this.data.end = parseInt(this.data.steps[this.data.steps.length-1].end);
      
      this.videoData['data'] = this.data;
      let response = await api.updateVideo(this.videoData, this.videoData['id']);
      if (response.status == 200) {
        this.$router.push('/management/video/list');
        this.$bvModal.hide('video-edit-modal');
      }
      else {
        this.$bvToast.toast("Failed to Update Video", {
          variant: "danger",
        });
        this.$bvModal.hide('video-edit-modal');
      }
    },
    validateTimeIntervals(steps) {
      let message = null;

      for (let i = 0; i < steps.length; i++) {
        const { start, end } = steps[i];
        start = Number(start);
        end = Number(end);

        if (!start || !end) {
          message = start ? 'Please Enter End Time' : 'Please Enter Start Time'
          message = !start && !end ? "Please Enter Start and End time" : !start ? "Please Enter Start Time" : !end ? "Please Enter End Time" : null;
          return {
            isValid: false,
            message: message
          };
        }

        if (end <= start) {
          return {
            isValid: false,
            message: 'Start Time needs to be lesser than End Time'
          };
        }

        if (i > 0 && start <= steps[i - 1].end) {
          return {
            isValid: false,
            message: 'Start Time cannot be lesser than previous End Time'
          };
        }
      }

      return {
        isValid: true,
        message: null
      };
    },
  },
  mounted() {
    this.getVideoData();
  }
}
</script>
<style scoped>
.form-control {
  padding: 5px;
}

.left-div,
.right-div {
  flex: 1;
}

.step-icon{
  color: #73bc44;
  cursor: pointer;
}

iframe {
  float: left;
  margin-left: 0%;
  width: 100%;
  height: "350";
  margin-right: 10px;
}

.input-box {
  margin-right: 10px;
}

.visible-drop {
  height: 60%;
  width: 100%;
}
</style>